import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyBPgoC6nztClTIQd1EmeimNPOt0mJtWQdk",
  authDomain: "mosquito-classifier.firebaseapp.com",
  databaseURL: "https://mosquito-classifier.firebaseio.com",
  projectId: "mosquito-classifier",
  storageBucket: "mosquito-classifier.appspot.com",
  messagingSenderId: "753578434099",
  appId: "1:753578434099:web:2343462e89ea9a17d68d46",
  measurementId: "G-8DHR2BGJP0"
};

firebase.initializeApp(config);

export const database = firebase.database();
export const storage = firebase.storage();
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = new firebase.auth();

export default firebase;
